import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('../views/StudioLayout.vue'),
    redirect: '/script',
    children: [
      {
        path: 'script',
        name: 'script',
        component: () => import('../views/studio/ScriptView.vue')
      },
      {
        path: 'storyboard',
        name: 'storyboard',
        component: () => import('../views/studio/StoryboardView.vue')
      },
      {
        path: 'assets',
        name: 'assets',
        component: () => import('../views/studio/AssetsView.vue')
      },
      {
        path: 'motion',
        name: 'motion',
        component: () => import('../views/studio/MotionView.vue')
      },
      {
        path: 'audio',
        name: 'audio',
        component: () => import('../views/studio/AudioView.vue')
      },
      {
        path: 'editor',
        name: 'editor',
        component: () => import('../views/studio/EditorView.vue')
      },
      {
        path: 'user',
        name: 'user',
        component: () => import('../views/studio/UserView.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
